export default "__VITE_ASSET__DQoF5nm0__"